// Organization API integration boundary. Uses the shared, CSRF/auth-aware api client.
// No business rules here — request in, normalized data out (errors bubble via apiError in components).
import { api } from "@/lib/api";

export const organizationService = {
  list: () => api.get("/organizations").then((r) => r.data),
  revenue: (year) => api.get(`/organizations/revenue${year && year !== "all" ? `?year=${year}` : ""}`).then((r) => r.data),
  priceLists: () => api.get("/price-lists").then((r) => r.data),
  create: (body) => api.post("/organizations", body).then((r) => r.data),
  update: (id, body) => api.put(`/organizations/${id}`, body).then((r) => r.data),
  archive: (id) => api.post(`/organizations/${id}/archive`).then((r) => r.data),
  remove: (id) => api.delete(`/organizations/${id}`).then((r) => r.data),
};
